/*
 * @Description: 资源库路由
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const resourceLibraryRouter: Array<RouteRecordRaw> = [
	{
		path: '/resource',
		component: Layout,
		redirect: '/resource/resourceLibrary',
		children: [
			{
				path: 'resourceLibrary',
				component: () => import(/* webpackChunkName: "ResourceLibrary" */ '@/views/resourceLibrary/index.vue'),
				name: 'ResourceLibrary',
				meta: { title: '资源库管理' }
			}
		]
	}
]

export default resourceLibraryRouter